import { FC } from 'react';
import { useMediaQuery } from 'modules/mui/hooks';
import { DefaultGrid, DesktopGrid } from './Grids';

export const Navigation: FC = () => {
  const { isDesktop } = useMediaQuery();

  return (
    <>
      {isDesktop && <DesktopGrid />}
      <DefaultGrid />
    </>
  );
};
